import './App.css';
import { Component } from 'react';

import Home from './components/Home';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './components/Login';
import VoiceJourney from './components/VoiceJourney';
// import Consent from './components/Consent';
import { Route, Switch } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { postMessage } from './utils/common.utils';
import Error from './components/Error';
import ConsentStatus from './components/ConsentStatus';
import Header from './components/common/Header';
import AccountDiscovery from './components/AccountDiscovery';
import AddNumber from './components/AddNumber';
import Toast from './components/Toast/ToastContainer';
import PaymentConsent from './components/PaymentConsent';
import { ConsentContext } from './components/Context/ConsentContext';
import { StepperProvider } from './components/Context/StepperContext';
import { registerEvent } from './utils/tracking.utils';
import AuthApis from './hepler/authApis.service';
import Loader from './components/Loader/Loader';
import NoAccountFoundExit from './components/NoAccountFoundExit';
import ConsentRenew from './components/ConsentRenew/ConsentRenew';
import ConsentRenewStatus from './components/ConsentRenew/ConsentRenewStatus';
import { store } from './store';
import { loadTranslations } from './store/translationSlice';
import { UserActionProvider } from './components/Context/UserActionContext';
import { Box, CircularProgress, Typography } from '@mui/material';
const defaultConfig = {
	fontFamily: 'Lato',
	primaryColor: '#017aff',
	secondaryColor: '#F5F5F5',
	headingColor: '#191c1f',
	subHeadingColor: '#0e65d7',
	textColor: '#757779',
	btnHeight: '48px',
	btnWidth: '327px',
	borderRadius: '40px',
};
class App extends Component {
	constructor(props) {
		super(props);
		const queryParams = new URLSearchParams(window.location.search);
		this.disableEvents = queryParams.get('disableEvents');
		this.protocol = queryParams.get('protocol');
		this.authApis = new AuthApis()
		registerEvent({
			'LINKED_ACCOUNTS_DISCOVERED': {
				category: 'discovery',
				fipId: '',
				count: 0,
			},
			'UNLINKED_ACCOUNTS_DISCOVERED': {
				category: 'discovery',
				fipId: '',
				count: 0,
			},
			'MULTIPLE_FIP_LINKING': {
				category: 'linking',
				stage: 'LINKING_OTP_INCORRECT,LINKING_FAILURE,LINKING_SUCCESS',
				count: 0,
				totalFips:0
			},
			'MULTIPLE_FIP_DISCOVERY': {
				category: 'discovery',
				stage: 'DISCOVERY_FAILED,ACCOUNTS_NOT_DISCOVERED,ACCOUNTS_DISCOVERED',
				count: 0,
				totalFips:0
			},
		});
		this.ecreq = queryParams.get('ecreq');
		this.reqdate = queryParams.get('reqdate');
		this.fi = queryParams.get('fi') ? queryParams.get('fi') : '';
		this.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		global.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		global.isAddAccount = queryParams.get('isAddAccount') ? true : false;
		global.mobileNumberArray = [];
		this.state = {
			isLoader: false,
			initialLoader: false,
			configDetails: defaultConfig,
			timerStart: false,
			sdkReady: false,
		};
		this.timerId = null;
	}
	async componentDidMount() {
		await window.finvuClient.open("", "" ,this.disableEvents ?? null,this.protocol ?? null);
		this.setState({ sdkReady: true });
		store.dispatch(loadTranslations('en'));
		if (!this.ecreq || !this.fi || !this.reqdate) {
			postMessage('session', 'FAILURE');
		}
	}	
	componentDidUpdate(prevProps, prevState) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			if (this.props.history.action === 'POP') {
				window.confirm(
					'Are you sure to go back ? Consent will not be actioned.'
				);
			}
		}
		if (this.state.timerStart && !prevState.timerStart) {
			this.timerId = setTimeout(() => {
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						statusCode: this.authApis.handleCancelTermination(),
					},
				});
		}, process.env.REACT_APP_SESSION_TIMEOUT_TIME)}
	}
	componentWillUnmount() {
		if (this.timerId) {
			clearTimeout(this.timerId);
		  }
		if (this.props.history.action === 'POP') {
			window.confirm('Are u sure u want to mountmount');
		}
	}

	toggleTimer = () => {
		this.setState({ timerStart: true });
	  };

	updateLoader = (val) => {
		this.setState({ isLoader: val });
	};
	updateInitialLoader = (val) => {
		this.setState({ initialLoader: val });
	};
	updateEntityID = (data) => {
		this.setState({ configDetails: data });
	};
	updateLoginStageLoader = (loginLoaderData) => {
		this.setState({loginStageStatus:{isLoading:loginLoaderData?.isLoading ?? false, loadingText:loginLoaderData?.loadingText ?? "", isSuccess:loginLoaderData?.isSuccess ?? false, successText:loginLoaderData?.successText ?? ""}});
		if(loginLoaderData?.isSuccess == true){
			setTimeout(() => {
				this.updateLoginStageLoader({isSuccess:false})
			},1000)
		}
	}

	render() {
		return (
			<ConsentContext>
				<StepperProvider>
					<UserActionProvider>
				<div
					className="App"
					style={{ 
						fontFamily: this.state.configDetails?.fontFamily,
						backgroundColor: this.state.configDetails?.darkTheme ? '#161616' : 'transparent',
						color: this.state.configDetails?.darkTheme ? '#FFFFFF' : '#000000',
						minHeight: '100vh'
					}}
				>
					<Header  customDetails={this.state.configDetails} />
					{this.ecreq && this.fi && this.reqdate ? (
						<Switch>
							<Route
								exact
								path="/"
								render={(props) => (
									<>
										<Login
											updateEntityID={this.updateEntityID}
											updateInitialLoader={this.updateInitialLoader}
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											toggleTimer={this.toggleTimer}
											sdkReady={this.state.sdkReady}
											updateLoginStageLoader={this.updateLoginStageLoader}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/home"
								render={(props) => (
									<>
										<Home
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/voice-journey"
								render={(props) => (
									<>
										<VoiceJourney
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/login/:fid?"
								render={(props) => (
									<>
										<Login
											updateEntityID={this.updateEntityID}
											updateInitialLoader={this.updateInitialLoader}
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											sdkReady={this.state.sdkReady}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/accounts/:number/:fid?"
								render={(props) => (
									<>
										<AccountDiscovery
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											updateInitialLoader={this.updateInitialLoader}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/payment-consent"
								render={(props) => (
									<>
										<PaymentConsent
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											updateInitialLoader={this.updateInitialLoader}

										/>
									</>
								)}
							/>
							<Route
								exact
								path="/NoAccountFound/:number"
								render={(props) => (
									<>
										<AddNumber
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/exit"
								render={(props) => (
									<>
										<NoAccountFoundExit
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/error"
								render={(props) => (
									<>
										<Error
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/consent-status"
								render={(props) => (
									<>
										<ConsentStatus
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
						<Route
							exact
							path="/consent-renew"
							render={(props) => (
								<>
									<ConsentRenew
										{...props}
										customDetails={this.state.configDetails}
									/>
								</>
							)}
						/>
						<Route
							exact
							path="/consent-renew-status"
							render={(props) => (
								<>
									<ConsentRenewStatus
										{...props}
										customDetails={this.state.configDetails}
									/>
								</>
							)}
						/>
					</Switch>
					) : (
						<div className="centervs px-2">
							<h1 style={{ fontFamily: this.state.configDetails?.fontFamily }}>
								Oops!
							</h1>
							<h2 style={{ fontFamily: this.state.configDetails?.fontFamily }}>
								404 Not Found
							</h2>
							<div
								className="error-details"
								style={{ fontFamily: this.state.configDetails?.fontFamily }}
							>
								Sorry, an error has occured, Requested page not found!
							</div>
						</div>
					)}

					{/* To display Success, Warning or Error messages to user */}
					<div className="toast-message">
						<Toast />
					</div>
					{/* To display API call Loader */}
					{this.state.isLoader ? (
						<div>
							<div className="application-loading-container">
								<div className="snippet" data-title=".dot-pulse">
									<div className="stage">
										<div className="dot-pulse-btn"></div>
									</div>
								</div>
								{/* <img className="image" src={LoaderImage} alt="" width="120" height="120"></img> */}
							</div>
						</div>
					) : null}
					{/* To display Initial Loader */}
					{this.state.initialLoader ? (
						<Loader/>
					) : null}
					{(this.state.loginStageStatus?.isLoading || this.state.loginStageStatus?.isSuccess) && (
						<Box sx={{
							height: "100vh",
							width: "100vw",
							position: "fixed",
							top: "0",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							background: "white",
							zIndex: "999999",
							flexDirection: "column"
						}}>
							{this.state.loginStageStatus.isLoading && <div>
								<CircularProgress size={"6rem"} />
								<Typography sx={{fontSize:"1.2rem", marginTop:"1rem", color:"grey"}}>{this.state.loginStageStatus?.loadingText ?? ""}</Typography>
								</div>}
							{this.state.loginStageStatus.isSuccess && <div>
								<img src='https://cdn.finvu.in/finvulogos/ellipse_1040.svg' style={{width:"6rem" , height:"6rem"}}>
								</img>
								<Typography sx={{fontSize:"1rem", marginTop:"1rem", color:this?.state?.configDetails?.primaryColor ?? "green"}}>{this?.state?.loginStageStatus?.successText ?? "Verified Succesfully."}</Typography>
								</div>}
						</Box>
					)}

				</div>
					</UserActionProvider>
				</StepperProvider>
			</ConsentContext>
		);
	}
}

export default App;
